
const REACT_APP_DOMAIN = process.env.REACT_APP_DOMAIN;


export class RestApiUtils {

  requestOptions = {
    "credentials": "omit",
    "headers": {
      "accept": "application/json",
      "content-type": "application/json"
    },
    "method": "GET",
    "mode": 'cors'
  };

  requestOptionsP = {
    "credentials": "omit",
    "headers": {
      "accept": "application/json",
  //    "accept": "multipart/form-data",
      "content-type": "application/json"
    },
    "method": "PUT",
    "mode": 'cors'
  };

  requestOptionsPO = {
    "credentials": "omit",
    "headers": {
      "accept": "application/json",
      "content-type": "application/json"
    },
    "method": "POST",
    "mode": 'cors'
  };

  async getBaseDetailByUrl(url) {

    try {
      const base_url = "https://wp-proxy-api.startupitalia.eu/api/url-to-postid/";
      let api_url = `${base_url}?p=${url}`;
      console.debug(`asking for url ${api_url}`);

      let res = await fetch(api_url, this.requestOptions).then(res => res.json());
      if (res['success']) {
        return res;
      }

    } catch (e) {
      console.error(`Not fount ${url} of wp-proxy-api`);
      console.error(e)
      // throw e;
    }

    try {
      const base_url = "https://admin.startupitalia.eu/wp-json/wpse/v1/url-to-postid";
      let api_url = `${base_url}?p=${url}`;
      console.debug(`asking for url ${api_url}`);
      return fetch(api_url, this.requestOptions).then(res => res.json());

    } catch (e) {
      console.error(e)
      throw e;
    }
  }

  async getLiveview(_params) {
    var params = _params;
    try {
      let res = null;
      //const base_url = process.env.PROXY_DOMAIN + "api/liveview/?page_size=12";
      //params = 'page=1&page_size=8';
      const base_url = `${REACT_APP_DOMAIN}/api/liveview/?${params}`

      console.debug(`asking for url ${base_url}`);

      const api_call = await fetch(base_url, this.requestOptions);

      if (api_call.status !== 200) {
        console.log('GET api_call.status: ', api_call.status);
        res = api_call.status;
      } else {
        res = await api_call.json();
      }

      return res;

    } catch (e) {
      //console.error(`Not fount ${base_url} of wp-proxy-api`);
      console.error(e)
      // throw e;
    }
  }

  async setLiveview(_params) {
    var params = _params;
    try {
      let res = {
        liveRes: null,
        error_code: 0,
        error_msg: ''
      };
      const base_url = `${REACT_APP_DOMAIN}/api/liveview/${params.id}/`;

      //console.debug(`asking for url ${base_url}`);
      this.requestOptionsP["body"] = JSON.stringify(params);
      console.log('requestOptionsP["body"]: ', this.requestOptionsP["body"]);

      const api_call = await fetch(base_url, this.requestOptionsP);

      if (api_call.status !== 200) {
        console.log('SET api_call.status: ', api_call.status);
        res.error_code = api_call.status;
        res.error_msg = await api_call.json();
      } else {
        res.liveRes = await api_call.json();
      }

      return res;

    } catch (e) {
      //console.error(`Not fount ${base_url} of wp-proxy-api`);
      console.error('errore: ', e)
      // throw e;
    }
  }

  async loginDJToken(_params) {
    var params = _params;
    try {
      let res = null;
      const base_url = `${REACT_APP_DOMAIN}/verify-wp-token/`;

      //console.debug(`asking for url ${base_url}`);
      this.requestOptionsPO["body"] = JSON.stringify(params);
      //console.log('requestOptionsPO: ', this.requestOptionsPO);

      const api_call = await fetch(base_url, this.requestOptionsPO);

      if (api_call.status !== 200) {
        console.log('api_call.status: ', api_call.status);
      } else {
        res = await api_call.json();
      }

      return res;

    } catch (e) {
      //console.error(`Not fount ${base_url} of wp-proxy-api`);
      console.error('errore: ', e)
      // throw e;
    }
  }

}
